import React, {useEffect, useState} from 'react';
import {useRecoilValue} from "recoil";
import {LinearProgress} from "@mui/material";
import {AbsentPollStepPage} from "./AbsentPollStepPage";
import {AttendPollStepPage} from "./AttendPollStepPage";
import {fromCreatePageState} from "../../states/appointment/createAppointmentAtom";
import {useNavbar} from "../../states/common/client";

export const PollPage = () => {
    // states
    const [step, setStep] = useState<number>(0);
    const [selectedAbsentDates, setSelectedAbsentDates] = useState<Date[]>([])
    const [selectedAttendDates, setSelectedAttendDates] = useState<Date[]>([])
    const fromCreatePage = useRecoilValue(fromCreatePageState); // 프로그레스바 표시를 위한 변수 - 약속 만들기를 통해 들어온 경우라면 프로그레스바를 3단계로 나눠서 표시해야 한다.

    // hooks
    const {setNavbarTitle, reset} = useNavbar()

    useEffect(() => {
        reset()
        setNavbarTitle("약속일자 고르기")
    }, [])

    useEffect(() => {
        const body = document.querySelector('body');
        if (body) {
            body.scrollTo(0, 0);
        }
    }, [step]);

    switch (step) {
        case 0:
            return (
                <>
                    <LinearProgress variant="determinate" value={fromCreatePage ? 66 : 50} />
                    <AbsentPollStepPage
                        setStep={setStep}
                        selectedAbsentDates={selectedAbsentDates}
                        selectedAttendDates={selectedAttendDates}
                        setSelectedAbsentDates={setSelectedAbsentDates}
                        setSelectedAttendDates={setSelectedAttendDates}
                    />
                </>
            )
        case 1:
        default:
            return (
                <>
                    <LinearProgress variant="determinate" value={100} />
                    <AttendPollStepPage
                        setStep={setStep}
                        selectedAbsentDates={selectedAbsentDates}
                        selectedAttendDates={selectedAttendDates}
                        setSelectedAbsentDates={setSelectedAbsentDates}
                        setSelectedAttendDates={setSelectedAttendDates}
                    />
                </>
            )
    }
}
